export const currentDate = () => {
  return new Date().toISOString().split('T')[0];
};

export const datePlus = (days = 0, months = 0, years = 0) => {
  let date = new Date();
  if (days) date.setDate(date.getDate() + days);
  if (months) date.setMonth(date.getMonth() + months);
  if (years) date.setFullYear(date.getFullYear() + years);
  return date.toISOString().split('T')[0];
};
